import gameiomModel from "gameiom/model/gameiom-model";
import wrapperImplementation from "gameiom/wrapper/wrapper-implementation";
import { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import SmartUIFlags from "slotworks/smart-ui/smart-ui-flags";
import Logger from "slotworks/utils/logger";
import log from "../logging";

declare const __DEBUG__: boolean;

/*
TS rewrite of wrapper interface version 1.1.4
Taken from
https://cdn.gameiom.com/gameiom/gameiom-game-wrapper-library/latest/gameWrapper.js
 */
export function injectWrapper() {
    (window as any).gameWrapper = (() => {
        // Prevents multiple setBusy or setIdle being sent to wrapper
        const gameWrapper = {
            insufficientFunds() {
                sendToWrapper({
                    action: "insufficientFunds"
                });
            },
            gameLoadingStarted() {
                sendToWrapper({
                    action: "gameLoadingStarted"
                });
            },
            gameLoadingEnded() {
                sendToWrapper({
                    action: "gameLoadingEnded"
                });
            },
            // Say to game wrapper that game is busy. Free spins, bonus game or spin are running
            setBusy() {
                sendToWrapper({
                    action: "gameRoundStarted"
                });
            },
            // Say to game wrapper that game is in a feature (bonus, freespins), should be called BEFORE setBusy
            enableFeatureMode() {
                sendToWrapper({
                    action: "enableFeatureMode"
                });
            },
            // Say to game wrapper that game is finished with a feature (bonus, freespins), should be called AFTER setIdle
            disableFeatureMode() {
                sendToWrapper({
                    action: "disableFeatureMode"
                });
            },
            // Say to game wrapper that game is in Idle state. Game wrapper will be able to show some screens
            setIdle() {
                wrapperImplementation.onResume.addOnce(() => SmartUIFlags.set(SmartUIFlag.EXTERNAL_DISABLE, false));
                SmartUIFlags.set(SmartUIFlag.EXTERNAL_DISABLE, true);
                sendToWrapper({
                    action: "gameRoundEnded"
                });

/////////////////////////////////
////////////////////////////////
//////////////////////////////////////////////////////////////
/////////////////
//////////////////////////
            },

            /* An int between 0 and 99 */
            loadProgressUpdate(percentValue: number) {

                if (percentValue === 100) {
                    return;
                }

                sendToWrapper({
                    action: "loadProgressUpdate",
                    data: {
                        percent: percentValue
                    }
                });
            },

            // Expects an integer
            winningsUpdate(winningValue: number) {

                if (gameiomModel.currency !== "TKN") {
                    winningValue = centsToCurrency(winningValue);
                }

                sendToWrapper({
                    action: "winningsUpdate",
                    data: {
                        winnings: winningValue
                    }
                });
            },

            // Expects an integer
            stakeUpdate(totalStake: number) {

                if (gameiomModel.currency !== "TKN") {
                    totalStake = centsToCurrency(totalStake);
                }

                sendToWrapper({
                    action: "stakeUpdate",
                    data: {
                        stake: totalStake
                    }
                });
            },

            // Expects integars
            balancesUpdate(cashValue: number, bonusValue?: number, balanceFudge?: number) {

                if (cashValue === null) {
                    return;
                }

                if (gameiomModel.currency !== "TKN") {
                    cashValue = centsToCurrency(cashValue);
                    if (bonusValue) {
                        bonusValue = centsToCurrency(bonusValue);
                    }
                    if (balanceFudge) {
                        balanceFudge = centsToCurrency(balanceFudge);
                    }
                }

                this.balancesUpdateDecimal(cashValue, bonusValue, balanceFudge);
            },

            balancesUpdateDecimal(cashValue: number, bonusValue?: number, balanceFudge?: number) {

                if (cashValue === null) {
                    return;
                }

                const data = {
                    action: "balancesUpdate",
                    data: {
                        balances: {
                            cash: cashValue
                        }
                    }
                };

                if (bonusValue && bonusValue > 0) {
                    (data.data.balances as any).bonus = bonusValue;
                }
                if (balanceFudge && balanceFudge > 0) {
                    (data.data as any).balanceFudge = balanceFudge;
                }
                sendToWrapper(data);
            },

            exitGame() {
                sendToWrapper({
                    action: "exitGame"
                });
            },
            enableAudio() {
                sendToWrapper({
                    action: "enableAudio"
                });
            },
            disableAudio() {
                sendToWrapper({
                    action: "disableAudio"
                });
            },
            gotoAccountsPage() {
                sendToWrapper({
                    action: "gotoAccountsPage"
                });
            },
            gotoDepositPage() {
                sendToWrapper({
                    action: "gotoDepositPage"
                });
            },

            isWrapperActive() {
                sendToWrapper({
                    action: "isWrapperActive"
                });
            },
            getOperatorInformation() {
                sendToWrapper({
                    action: "getOperatorInformation"
                });
            },
            getScreenSize() {
                sendToWrapper({
                    action: "getScreenSize"
                });
            },
            gamePopupShown() {
                sendToWrapper({
                    action: "gamePopupShown"
                });
            },

            gamePopupHidden() {
                sendToWrapper({
                    action: "gamePopupHidden"
                });
            },

            /*
            To override
             */

            onWrapperMessage(action: string, data: any) {
                Logger.info("Wrapper Message", action, data);
            }
        };

        // send message to wrapper
        function sendToWrapper(data: any) {
            if (!data) {
                return;
            }

            let logString = "Sending to Gameiom Wrapper: " + data.action;
            if (data.data) {
                logString += " " + JSON.stringify(data.data);
            }

            log(logString);

            window.parent.postMessage(JSON.stringify(data), "*");
        }

        // subscribe to messages from game wrapper client
        window.addEventListener("message", (message: any) => {
            let data;
            let action;

            try {
                data = JSON.parse(message.data);
                action = data.action;
            } catch (e) {
                return;
            }

            gameWrapper.onWrapperMessage(action, data);
        }, false);

        function centsToCurrency(input: number) {
            return +(input / 100).toFixed(2);
        }

        return gameWrapper;
    })();
}
